module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_3_1_2.8bcc5a0c.png";